import axios from "axios";
import {clearAccessTokenAndRedirectToLogin, getHeader, userProfileUrl} from "../../config";
import {types} from "../types/globalTypes";
import {userTypes} from "../types/userTypes";


export const profile = () => {
    return (dispatch) => {
        dispatch({
            type: types.ERROR_500,
            payload: false,
        });
        axios.post(userProfileUrl, {}, {headers: getHeader()}).then(response => {
            if (response.data.Error.code === 20) {
                dispatch({
                    type: userTypes.GET_PROFILE,
                    payload: response.data.Response,
                });
                if (window.location.href.indexOf("profile") > -1)
                    document.title = response.data.Response ? response.data.Response.name : "Helping Doctors Save Lives"
            }
        }).catch(error => {
            if (error) {
                clearAccessTokenAndRedirectToLogin(error);
                console.log("error here", error);
                dispatch({
                    type: types.ERROR_500,
                    payload: true,
                });

            }
        })
    }
};
export const authTogglePopUpStatus = (status) => {
    return (dispatch) => {
        dispatch({
            type: userTypes.AUTH_TOGGLE_POP_UP_STATUS,
            payload: status,
        })
    }
};
export const setUserUniqueId = (unique_id) => {
    return (dispatch) => {
        dispatch({
            type: userTypes.SET_USER_UNIQUE_ID,
            payload: unique_id,
        })
    }
};
export const succeedAuth = () => {
    return (dispatch) => {
        dispatch({
            type: userTypes.SUCCEED_AUTH,
            payload: true,
        })
    }
};

export const logout = () => {
    return(dispatch) => {
        dispatch({
            type: userTypes.LOGOUT,
            payload: null,
        });
    }
};